import * as api from '../../../api/purity/purityApi';
import {
  FETCH_PURITIES_REQUEST,
  FETCH_PURITIES_SUCCESS,
  FETCH_PURITIES_FAILURE,
  CREATE_PURITY,
  UPDATE_PURITY,
  DELETE_PURITY
} from '../../types/purity/purityTypes';

export const fetchPurities = () => async (dispatch) => {
  dispatch({ type: FETCH_PURITIES_REQUEST });
  try {
    const response = await api.fetchPurities();
    dispatch({ type: FETCH_PURITIES_SUCCESS, payload: response.data });
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to fetch purities';
    dispatch({ type: FETCH_PURITIES_FAILURE, payload: errorMessage });
    throw new Error(errorMessage);
  }
};

export const createPurity = (data) => async (dispatch) => {
  try {
    const response = await api.createPurity(data);
    const newPurity = { id: response.data.id, ...response.data.data };
    dispatch({ type: CREATE_PURITY, payload: newPurity });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to create purity';
    throw new Error(errorMessage);
  }
};

export const updatePurity = (id, data) => async (dispatch) => {
  try {
    const response = await api.updatePurity(id, data);
    dispatch({ type: UPDATE_PURITY, payload: { id, data } });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to update purity';
    throw new Error(errorMessage);
  }
};

export const deletePurity = (id) => async (dispatch) => {
  try {
    const response = await api.deletePurity(id);
    dispatch({ type: DELETE_PURITY, payload: id });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message || 'Failed to delete purity';
    throw new Error(errorMessage);
  }
};
